import type { EmptyStateTemplateProps } from './index';

export default function EmptyStateTemplate({
  classes,
  illustration,
  icon,
  headingLevel,
  title,
  description,
  actions,
}: EmptyStateTemplateProps) @{
  <div class={classes} data-dls-component="EmptyState">
    @if (illustration !== undefined) {
      <div class="empty-state-illustration">
        @if (illustration.image !== null) {
          <img src={illustration.image} alt="" aria-hidden="true" />
        } @else {
          <>{illustration.content}</>
        }
      </div>
    }
    @if (icon !== undefined) {
      <div class={icon.classes} aria-hidden="true" style={icon.style}>{icon.content}</div>
    }
    @switch (headingLevel) {
      @case 1: {
        <h1 class="empty-state-title">{title()}</h1>
      }
      @case 2: {
        <h2 class="empty-state-title">{title()}</h2>
      }
      @case 3: {
        <h3 class="empty-state-title">{title()}</h3>
      }
      @case 4: {
        <h4 class="empty-state-title">{title()}</h4>
      }
      @case 5: {
        <h5 class="empty-state-title">{title()}</h5>
      }
      @default: {
        <h6 class="empty-state-title">{title()}</h6>
      }
    }
    @if (description() !== undefined) {
      <p class="empty-state-description">{description()}</p>
    }
    @if (actions.length > 0) {
      <div class="empty-state-actions">
        @for (const action of actions; key action.key) {
          <button type="button" class={action.classes} onClick={action.onClick}>{action.label}</button>
        }
      </div>
    }
  </div>
}
